/**
 * One order number from the receipt to the customer's phone (owner's decision, 2026-10-26): in a
 * shop, the number the cashier types from the receipt IS the ticket's number — on the cup, the
 * board, the customer's phone, the lock-screen card and the TV. Used by the server (stores it) and
 * the staff screen (matches what the barista types), so both read "٥٧", "#57" and " 57" the same.
 */
export function normalizeOrderNumber(raw: string): string {
  return raw
    .replace(/\p{Cf}/gu, '') // invisible marks (left-to-right, zero-width…) from Arabic keyboards or a paste
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660)) // Arabic-Indic digits
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0)) // Persian digits
    .trim()
    .replace(/^#+\s*/, '')
    .replace(/\s+/g, ' ')
    .toUpperCase();
}
